// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isAgentConsoleConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      app_group: string,
      agent_name: string,
      model_owner: string,
      total_invocations: number,
      credit_ratio: number,
      credits_used: number,
    })
  ),
});
